"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExchangeRolEchainPartsV1 = exports.isExchangeRolEchainPartsNumLinksV1 = exports.isExchangeRolEchainPartsLinkV1 = void 0;
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const isExchangeRolEchainPartsLinkV1 = (whatever) => {
    if (!(0, echain_shared_ts_utils_1.isDefinedObject)(whatever)) {
        return false;
    }
    const obj = whatever;
    return Boolean(obj.ArtNr);
};
exports.isExchangeRolEchainPartsLinkV1 = isExchangeRolEchainPartsLinkV1;
const isExchangeRolEchainPartsNumLinksV1 = (whatever) => {
    if (!(0, echain_shared_ts_utils_1.isDefinedObject)(whatever)) {
        return false;
    }
    const obj = whatever;
    return (echain_shared_ts_utils_1.NumberUtils.isDefinedNumber(obj.NumRolLinks) &&
        echain_shared_ts_utils_1.NumberUtils.isDefinedNumber(obj.NumStandardLinks) &&
        echain_shared_ts_utils_1.NumberUtils.isDefinedNumber(obj.NumAdapterLinks) &&
        echain_shared_ts_utils_1.NumberUtils.isDefinedNumber(obj.NumAutoglideLinks) &&
        echain_shared_ts_utils_1.NumberUtils.isDefinedNumber(obj.NumModifiedLinks));
};
exports.isExchangeRolEchainPartsNumLinksV1 = isExchangeRolEchainPartsNumLinksV1;
const isExchangeRolEchainPartsV1 = (whatever) => {
    if (!(0, echain_shared_ts_utils_1.isDefinedObject)(whatever)) {
        return false;
    }
    const obj = whatever;
    return ((0, echain_shared_quantities_1.isQuantityJson)(obj.TotalWeight) &&
        (0, exports.isExchangeRolEchainPartsNumLinksV1)(obj.NumLinks) &&
        (0, exports.isExchangeRolEchainPartsLinkV1)(obj.RolLink) &&
        (0, exports.isExchangeRolEchainPartsLinkV1)(obj.StandardLink) &&
        (obj.AdapterLink ? (0, exports.isExchangeRolEchainPartsLinkV1)(obj.AdapterLink) : true) &&
        (obj.AutoglideLink ? (0, exports.isExchangeRolEchainPartsLinkV1)(obj.AutoglideLink) : true) &&
        (obj.ModifiedLink ? (0, exports.isExchangeRolEchainPartsLinkV1)(obj.ModifiedLink) : true));
};
exports.isExchangeRolEchainPartsV1 = isExchangeRolEchainPartsV1;
//# sourceMappingURL=ExchangeRolEchainPartsV1.js.map